export const INITIALIZE_STEP_ENVIRONMENT = 'INITIALIZE_STEP_ENVIRONMENT';
export type INITIALIZE_STEP_ENVIRONMENT = typeof INITIALIZE_STEP_ENVIRONMENT;

export const INITIALIZE_STEP_ENVIRONMENT_SUCCESS =
  'INITIALIZE_STEP_ENVIRONMENT_SUCCESS';
export type INITIALIZE_STEP_ENVIRONMENT_SUCCESS = typeof INITIALIZE_STEP_ENVIRONMENT_SUCCESS;

export const INITIALIZE_STEP_ENVIRONMENT_FAILED =
  'INITIALIZE_STEP_ENVIRONMENT_FAILED';
export type INITIALIZE_STEP_ENVIRONMENT_FAILED = typeof INITIALIZE_STEP_ENVIRONMENT_FAILED;

export const SUBMIT_STEP_ENVIRONMENT = 'SUBMIT_STEP_ENVIRONMENT';
export type SUBMIT_STEP_ENVIRONMENT = typeof SUBMIT_STEP_ENVIRONMENT;

export const SET_REQUEST_ID = 'SET_REQUEST_ID';
export type SET_REQUEST_ID = typeof SET_REQUEST_ID;

export const RESET_STATUS = 'RESET_STATUS';
export type RESET_STATUS = typeof RESET_STATUS;
